import { createSelector } from '@ngrx/store';

import { LOCATION_TYPES } from '../../global.constants';
import { brandingFeature } from '../../state/branding.store';
import { jobToolFeature } from '../job-tool.reducer';

export const selectSectionSaveButtonDisabledMessage = (sectionName: 'Customer' | 'Locations') => createSelector(
	jobToolFeature.selectInvalidLocations,
	(invalidLocations) => {
	  if (!invalidLocations) return null;

	  if (sectionName === 'Customer') {
		const invalidCustomerLocations = invalidLocations.filter(loc => loc === 'billing');
		return invalidCustomerLocations.length ? 'Billing address is invalid.' : null;
	  }

	  if (sectionName === 'Locations') {
		const invalidJobLocations = invalidLocations.filter(loc => LOCATION_TYPES.includes(loc));
		return invalidJobLocations.length ? 'Job locations are invalid.' : null;
	  }

	  return null;
	}
);

export const selectJobIsShared = createSelector(
	jobToolFeature.selectJob,
	brandingFeature.selectBranding,
	(job, branding) => {
		if (!job || !branding) return null;
		const jobZone = job?.zone?.type === 'area'
			? job?.zone?.parent?.id
			: job?.zone?.id;
	  	return jobZone !== branding.zoneId;
	}
);